import { PersonalLiabilityPolicyState } from "./types";

export const defaultState = (): PersonalLiabilityPolicyState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    personalLiabilityPolicies: [],
    links: {}
  };
};

export const state = defaultState();
